export const ForwardIconWhite = () => (
    <svg
        width='51'
        height='51'
        viewBox='0 0 51 51'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle
            cx='25.5'
            cy='25.5'
            r='25.5'
            fill='white'
        />
        <path
            d='M35.7071 26.7071C36.0976 26.3166 36.0976 25.6834 35.7071 25.2929L29.3431 18.9289C28.9526 18.5384 28.3195 18.5384 27.9289 18.9289C27.5384 19.3195 27.5384 19.9526 27.9289 20.3431L33.5858 26L27.9289 31.6569C27.5384 32.0474 27.5384 32.6805 27.9289 33.0711C28.3195 33.4616 28.9526 33.4616 29.3431 33.0711L35.7071 26.7071ZM15 27H35V25H15V27Z'
            fill='#446A90'
        />
    </svg>
);

export const ForwardIconGrey = () => (
    <svg
        width='51'
        height='51'
        viewBox='0 0 51 51'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle
            cx='25.5'
            cy='25.5'
            r='25.5'
            fill='#F3F0EF'
        />
        <path
            d='M35.7071 26.7071C36.0976 26.3166 36.0976 25.6834 35.7071 25.2929L29.3431 18.9289C28.9526 18.5384 28.3195 18.5384 27.9289 18.9289C27.5384 19.3195 27.5384 19.9526 27.9289 20.3431L33.5858 26L27.9289 31.6569C27.5384 32.0474 27.5384 32.6805 27.9289 33.0711C28.3195 33.4616 28.9526 33.4616 29.3431 33.0711L35.7071 26.7071ZM15 27H35V25H15V27Z'
            fill='#CDCDCD'
        />
    </svg>
);

export const EditPencil = () => (
    <svg
        width='11'
        height='12'
        viewBox='0 0 11 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M0.710938 11.2557C0.710938 10.9317 0.973581 10.6691 1.29757 10.6691H9.51038C9.83437 10.6691 10.097 10.9317 10.097 11.2557C10.097 11.5797 9.83437 11.8423 9.51038 11.8423H1.29757C0.973581 11.8423 0.710938 11.5797 0.710938 11.2557Z'
            fill='#1293DE'
        />
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M8.96397 0.798607C8.04759 -0.117762 6.56187 -0.117766 5.64549 0.798602L1.59418 4.8499C1.43141 5.01266 1.32012 5.21969 1.27416 5.44523L0.735748 8.08725C0.567834 8.91121 1.29574 9.63909 2.1197 9.47116L4.76163 8.93268C4.98716 8.88671 5.19418 8.77542 5.35693 8.61267L9.40825 4.56138C10.3246 3.645 10.3246 2.15927 9.40825 1.24289L8.96397 0.798607ZM6.47511 1.62822C6.9333 1.17004 7.67616 1.17004 8.13435 1.62823L8.57863 2.07251C9.03682 2.5307 9.03682 3.27357 8.57863 3.73176L8.33715 3.97323L6.23363 1.86971L6.47511 1.62822ZM5.404 2.69932L3.30047 4.80285L2.47085 5.63246L2.42379 5.67952L1.88538 8.32153L4.52732 7.78305L4.57438 7.73599L5.404 6.90638L7.50753 4.80285L5.404 2.69932Z'
            fill='#1293DE'
        />
    </svg>
);

export const BinRed = () => {
    return (
        <svg
            width='13'
            height='15'
            viewBox='0 0 13 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.1101 4.97636H1.77673V4.75413C1.77673 2.44851 3.66567 0.531796 5.99906 0.531796H7.33243C9.63804 0.531796 11.5548 2.44851 11.5548 4.75413V4.97636H10.2214V4.75413C10.2214 3.17075 8.9158 1.86516 7.33243 1.86516H5.99906C4.38791 1.86516 3.1101 3.17075 3.1101 4.75413V4.97636ZM0.443359 6.53195C0.443359 6.17083 0.721144 5.86527 1.11004 5.86527H12.2214C12.5826 5.86527 12.8881 6.17083 12.8881 6.53195C12.8881 6.92085 12.5826 7.19864 12.2214 7.19864H12.0548L11.2492 13.5877C11.1659 14.2544 10.5825 14.7544 9.91583 14.7544H3.38788C2.7212 14.7544 2.13785 14.2544 2.05451 13.5877L1.27671 7.19864H1.11004C0.721144 7.19864 0.443359 6.92085 0.443359 6.53195ZM3.38788 13.421H9.91583L10.6936 7.19864H2.61008L3.38788 13.421Z'
                fill='#FF0000'
                fill-opacity='0.75'
            />
        </svg>
    );
};
